import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApplicationModule } from '@klickdata/core/application';
import { JwtInterceptor } from '@auth0/angular-jwt';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        ApplicationModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true,
        },
    ]
})
export class HttpModule {}
